import PropTypes from 'prop-types';
import AppActions from '../../actions/app';
import EloquaActions from '../../actions/eloqua';
import TranslationUtil from '../../utils/TranslationUtil';

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const {
        app,
        location,
        lead
    } = state;

    const {
        address,
        serverAddressValidation,
        latLng,
        geocoderLatLng,
        partialMatch
    } = location;

    const { fingerprint } = app;

    const { bedroomCount, bathroomCount } = app.lyp;

    // Null check if we don't have the estimate yet
    const locale = app.locale.canonical;

    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const genericCreatePropertyErrorMessage = translations.getTranslation('Vrbo.lyp.estimate.property.creation.error.message');

    return {
        // app
        fingerprint,
        locale,
        // lyp
        bedroomCount,
        bathroomCount,
        // lead
        newSupplier: lead.newSupplier,
        // location
        latLng,
        serverAddressValidation,
        partialMatch,
        address,
        geocoderLatLng,
        // translations
        genericCreatePropertyErrorMessage
    };
};

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
    setCreatedPropertyTriad: triad => dispatch(AppActions.setCreatedPropertyTriad(triad)),
    setCreatePropertyError: error => dispatch(AppActions.setCreatePropertyError(error)),
    setExpediaId: expediaId => dispatch(AppActions.setExpediaId(expediaId)),
    setInternalUser: isInternalUser => dispatch(AppActions.setInternalUser(isInternalUser)),
    sendEloquaData: data => dispatch(EloquaActions.sendEloquaCompetitorLinkCapture(data))
});

const proptypes = {
    // translation props
    genericCreatePropertyErrorMessage: PropTypes.string.isRequired,
    // location props
    address: PropTypes.object.isRequired,
    serverAddressValidation: PropTypes.object.isRequired,
    latLng: PropTypes.object.isRequired,
    geocoderLatLng: PropTypes.object.isRequired,
    partialMatch: PropTypes.bool.isRequired,
    // app props
    fingerprint: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    // lyp props
    bedroomCount: PropTypes.number.isRequired,
    bathroomCount: PropTypes.number.isRequired,
    // lead props
    newSupplier: PropTypes.bool.isRequired,
    // pageflow props
    pageFlow: PropTypes.shape({
        next: PropTypes.func
    }).isRequired,
    // app actions
    setCreatedPropertyTriad: PropTypes.func.isRequired,
    setCreatePropertyError: PropTypes.func.isRequired,
    setExpediaId: PropTypes.func.isRequired,
    setInternalUser: PropTypes.func.isRequired,
    // eloqua actions
    sendEloquaData: PropTypes.func.isRequired
};

export {
    proptypes,
    mapStateToProps,
    mapDispatchToProps
};
